const mapStyle1 = new URL(
  "../assets/img/map-styles/map-style-1.webp",
  import.meta.url,
).href;
const mapStyle2 = new URL(
  "../assets/img/map-styles/map-style-2.webp",
  import.meta.url,
).href;
const mapStyle3 = new URL(
  "../assets/img/map-styles/map-style-3.webp",
  import.meta.url,
).href;
const mapStyle4 = new URL(
  "../assets/img/map-styles/map-style-4.webp",
  import.meta.url,
).href;
const mapStyle5 = new URL(
  "../assets/img/map-styles/map-style-5.webp",
  import.meta.url,
).href;
const mapStyle6 = new URL(
  "../assets/img/map-styles/map-style-6.webp",
  import.meta.url,
).href;
const mapStyle7 = new URL(
  "../assets/img/map-styles/map-style-7.webp",
  import.meta.url,
).href;
const mapStyle8 = new URL(
  "../assets/img/map-styles/map-style-8.webp",
  import.meta.url,
).href;
const mapStyleDelft = new URL(
  "../assets/img/map-styles/map-style-delft.webp",
  import.meta.url,
).href;
const cardWidth = "22%";

const cityMapStyles = [
  { id: "2", image: mapStyle1, label: "Modern", labelKey: "modern" },
  { id: "4", image: mapStyle4, label: "Zwart", labelKey: "black" },
  { id: "1", image: mapStyle2, label: "Oceaan", labelKey: "ocean" },
  { id: "3", image: mapStyle3, label: "Schets", labelKey: "sketch" },
  { id: "5", image: mapStyle6, label: "Beige", labelKey: "beige" },
  { id: "6", image: mapStyle7, label: "Kleur", labelKey: "color" },
  { id: "8", image: mapStyle5, label: "Chic", labelKey: "chic" },
  { id: "7", image: mapStyle8, label: "Grijs", labelKey: "gray" },
  { id: "9", image: mapStyleDelft, label: "Delft", labelKey: "delft" },
];

const sportsmapStyles = [
  { id: "1", image: mapStyle8, label: "Grijs", labelKey: "gray" },
  { id: "3", image: mapStyle4, label: "Zwart", labelKey: "black" },
  { id: "2", image: mapStyle7, label: "Kleur", labelKey: "color" },
];

class MapStyleSelector extends HTMLElement {
  state = {
    printType: "paper",
    posterStyle: "1",
  };

  disabledByPrintType = {
    acryl: ["4", "5", "8"],
    aluminium: ["4", "5", "6", "7", "8"],
    tegel: ["4", "8"],
  };

  connectedCallback() {
    this.render();
    this.bindEvents();
    this.applyAll();
  }

  setState(next = {}) {
    this.state = { ...this.state, ...next };
    this.applyAll();
  }

  bindEvents() {
    this.addEventListener("click", (e) => {
      const el = e.target.closest(".js-map-style");
      if (!el || !this.contains(el)) return;

      const posterStyle = String(el.dataset.mapStyle);

      // als hij verborgen is: negeer klik
      if (el.classList.contains("d-none")) return;

      this.setState({ posterStyle });

      // laat main.js weten dat er gekozen is
      this.dispatchEvent(
        new CustomEvent("map-style-change", {
          detail: { posterStyle },
          bubbles: true,
        }),
      );
    });
  }

  applyAll() {
    this.applyAvailability();
    this.applySelection();
  }

  applySelection() {
    const { posterStyle } = this.state;
    this.querySelectorAll(".js-map-style").forEach((el) => {
      el.classList.toggle(
        "active",
        String(el.dataset.mapStyle) === String(posterStyle),
      );
    });
  }

  applyAvailability() {
    const { printType } = this.state;
    const disabled = this.isSportsmap
      ? ["acryl", "aluminium", "tegel"].includes(printType)
        ? ["3"]
        : []
      : (this.disabledByPrintType[printType] ?? []);

    this.querySelectorAll(".js-map-style").forEach((el) => {
      const id = String(el.dataset.mapStyle);
      const isDisabled = disabled.includes(id);
      el.classList.toggle("d-none", isDisabled);
    });
  }

  get isSportsmap() {
    return this.getAttribute("variant") === "sportsmap";
  }

  render() {
    const styles = this.isSportsmap ? sportsmapStyles : cityMapStyles;

    this.innerHTML = /* html */ `
      <div class="d-flex flex-wrap gap-3 mb-3 mt-2">
        ${styles
          .map(
            ({ id, image, label, labelKey }) => /* html */ `
              <div class="js-map-style flex-shrink-0 selectable-card text-center p-1" style="flex-basis: ${cardWidth};" data-map-style="${id}">
                <img src="${image}" class="img-fluid w-100 h-auto rounded" />
                <small data-i18n="components.mapStyleSelector.${labelKey}">${label}</small>
              </div>
            `,
          )
          .join("")}
      </div>
    `;
  }
}

customElements.define("map-style-selector", MapStyleSelector);
